
import { Outlet } from "react-router";
import { Env } from "../config";

export default function LiveRouteGuard() {
    if (Env.REACT_APP_IS_POSTER) {
        return <p role="alert">Page not found</p>;
    }

    return <Outlet />;
}
